<template>
  <div>
    <div class="row pt-3">
      <div class="col-6">
        <div class="border border-gray-500">
          <div class="p-2">
            <quick-send-list-panel
                v-bind="quickSendListPanel"
            ></quick-send-list-panel>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="border border-gray-500">
          <div class="p-2">
            <div class="d-flex justify-content-end">
              <add-send-list-conversation-item-panel></add-send-list-conversation-item-panel>
              <export-item-panel></export-item-panel>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row pt-3">
      <div class="col-6">
        <div class="border border-gray-500">
          <div class="pt-2 pb-2 bg-gray-500 text-center">
            <h5 class="mb-0">GROUPS</h5>
          </div>
          <div class="p-2">
            <div class="mt-2">
              <brand-toggle
                  v-bind="brandToggle"
              ></brand-toggle>
            </div>
            <send-list-on-send-list-page
                v-bind="sendListOnSendListPage"
            ></send-list-on-send-list-page>
          </div>
        </div>
      </div>
      <content-tabs-on-send-list-page
      ></content-tabs-on-send-list-page>
    </div>
    <modal-send-list-form></modal-send-list-form>
    <quick-bulk-message :excludedConversationIds="excludedConversationIds"></quick-bulk-message>
    <email-bulk-message-dialog :excludedConversationIds="excludedConversationIds"></email-bulk-message-dialog>
    <modal-add-send-list-conversation-form></modal-add-send-list-conversation-form>
    <modal-edit-send-list-conversation-form></modal-edit-send-list-conversation-form>
    <conversation-dialog v-bind="chatProps"></conversation-dialog>
    <move-to-group-dialog :search-url="sendListSearchUrl"></move-to-group-dialog>
  </div>
</template>

<script>
import QuickSendListPanel from '../../../components/quick-send-list/panel';
import AddSendListConversationItemPanel from '../../../components/shared/send-list-conversation/add-item-panel';
import SendListOnSendListPage from './send-list-wrapper';
import ContentTabsOnSendListPage from './content-tabs';
import ModalSendListForm from '../../../components/quick-send-list/modal-form-dialog';
import ConversationDialog from './conversation-dialog/dialog';
import StoreModule from '../../../store/send-list-list-page';
import Filter from "../../../store/filter";
import {mapState} from "vuex";
import EmailBulkMessageDialog from "../../../components/email-bulk-message/message-dialog.vue";
import MoveToGroupDialog from "./move-to-group-dialog";
import ExportItemPanel from '../../../components/shared/send-list-conversation/export-panel';


export default {
  components: {
    QuickSendListPanel,
    AddSendListConversationItemPanel,
    SendListOnSendListPage,
    ContentTabsOnSendListPage,
    ModalSendListForm,
    ConversationDialog,
    EmailBulkMessageDialog,
    MoveToGroupDialog,
    ExportItemPanel,
  },

  props: {
    quickSendListPanel: Object,
    brandToggle: Object,
    sendListOnSendListPage: Object,
    chatProps: Object,
    sendListSearchUrl: String,
  },

  computed: {
    ...mapState('page', {excludedConversationIds: 'excludedConversationIds'}),
  },

  beforeCreate() {
    this.$store.registerModule('sendListFilter', Filter);
    this.$store.registerModule('page', StoreModule);
  }
}
</script>
